export const deepCopy = (object: any) => JSON.parse(JSON.stringify(object));
